// The perspective-quad test over a corner list, the one polygon helper that outlives the outline lib. Outline geometry (anchors, segments, flattening, orientation, pointInPolygon, edgeDepth) lives in ~/lib/outline/path.

const EPS = 1e-9

const cross = (o, a, b) => (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0])

/** Four corners turning one way at every corner: the only shape a perspective map covers without folding through infinity. */
export const isConvexQuad = corners => {
	if (corners?.length !== 4) return false
	let sign = 0
	for (let i = 0; i < 4; i++) {
		const turn = cross(corners[i], corners[(i + 1) % 4], corners[(i + 2) % 4])
		if (Math.abs(turn) <= EPS) return false
		const s = Math.sign(turn)
		if (sign && s !== sign) return false
		sign = s
	}
	return true
}
